export default "__VITE_ASSET__M2MilJ$G__"